module.exports = __webpack_public_path__ + "img/firacode-medium.212d509.svg";